import { render } from "./Import.vue?vue&type=template&id=23957abb&ts=true"
import script from "./Import.vue?vue&type=script&lang=ts"
export * from "./Import.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__